export default {
	state: {
		intervals: []
	},

	actions: {
		set(actionContext, interval) {
			return new Promise((resolve, reject) => {
				try {
					var filteredInterval = actionContext.state.intervals.filter(x => x.name == interval.name)[0]

					if (filteredInterval != null)
						actionContext.commit("clear", filteredInterval.name)

					actionContext.commit("set", interval)

					resolve()
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		},
		clearAll(actionContext) {
			return new Promise((resolve, reject) => {
				try {
					for (var i = 0; i < actionContext.state.intervals.length; i++) {
						var interval = actionContext.state.intervals[i]

						actionContext.commit("clear", interval.name)
					}

					resolve()
				}
				catch (exception) {
					actionContext.dispatch("MopaneApi/processErrorResponse", exception, { root: true })
					actionContext.commit("Loading/hide", null, { root: true })

					reject(exception)
				}
			})
		}
	},

	mutations: {
		set(state, interval) {
			var id = setInterval(interval.callback, interval.timeout)

			state.intervals.push({ name: interval.name, id })
		},
		clear(state, intervalName) {
			var intervals = state.intervals.filter(x => x.name == intervalName)

			for (var i = 0; i < intervals.length; i++) {
				var interval = intervals[i]

				clearInterval(interval.id)

				state.intervals = state.intervals.filter(x => x.name != interval.name)
			}
		}
	},

	namespaced: true
}